"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { LoginProvider, useLogin } from "@/src/core/auth/LoginContext";

// The modal (the phone input, Firebase's OTP, the forms) loads on the first sign-in, not
// with every page: it is a tap away and only for signed-out visitors.
const LoginModal = dynamic(
  () => import("@/src/features/auth/components/LoginModal"),
  { ssr: false },
);

const LoginModalWrapper: React.FC = () => {
  const { isLoginModalOpen, closeLoginModal } = useLogin();
  // Kept mounted once opened, so closing still animates out.
  const [wanted, setWanted] = useState(false);
  useEffect(() => {
    if (isLoginModalOpen) setWanted(true);
  }, [isLoginModalOpen]);

  return wanted ? (
    <LoginModal isOpen={isLoginModalOpen} onClose={closeLoginModal} />
  ) : null;
};

interface ILoginSystemProps {
  children: React.ReactNode;
}

const LoginSystem: React.FC<ILoginSystemProps> = ({ children }) => {
  return (
    <LoginProvider>
      {children}
      <LoginModalWrapper />
    </LoginProvider>
  );
};

export default LoginSystem;
